export enum Packages {
    PFPF = "PFPF",
    PFF = "PFF",
    PFPCS = "PFPCS",
    PFTT = "PFTT",
    PFP = "PFP",
    PFCS = "PFCS",
    PF = "PF",
    PMA = "PMA",
    HS = "HS",
    PFTTF = "PFTTF",
    PFPTTF = "PFPTTF",
}